import AddGoodsmarkModal from './AddGoodsmarkModal';

export default AddGoodsmarkModal;
